import { render, staticRenderFns } from "./MultiplicationAndDivisionMathMagic.vue?vue&type=template&id=58362754&lang=pug&"
import script from "./MultiplicationAndDivisionMathMagic.vue?vue&type=script&lang=js&"
export * from "./MultiplicationAndDivisionMathMagic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports